module.exports = __webpack_public_path__ + "img/NE.b5d10b07.svg";